import { hot } from 'react-hot-loader';

import { ApolloProvider } from '@apollo/client';
import { apolloClient, windowExists } from '@classity-edtech/ui-base';
import FlashMessage from './components/FlashMessage';
import { GoogleOAuthProvider } from '@react-oauth/google';

import AppRoutes from './routes/routes';

const App = () => {
  return (
    <ApolloProvider client={apolloClient as any}>
      <GoogleOAuthProvider clientId={(windowExists?.__UI_CONFIG__ as any)?.googleClientId}>
        <FlashMessage />
        <AppRoutes />
      </GoogleOAuthProvider>
    </ApolloProvider>
  );
};

App.propTypes = {};

App.defaultProps = {};

export default hot(module)(App);
